import { BrowserCache } from '@/utils/cache'
import { createStore } from 'vuex'
import { global } from './global'
import { models } from './models'
import { agents } from './agents'
import { embeddings } from './embeddings'
import { prompts } from './prompts'
import { mcp } from './mcp'
import { providers } from './providers'
import { account } from './account'
import { workflows } from './workflows'
import { factories } from './factories'
import { scheduledRuns } from './scheduledRuns'
import { admin } from './admin'
import { voices } from './voices'
import { subscription } from './subscription'
import { pricing } from './pricing'
import { videoProcessing } from './videoProcessing'
import { configAssistant } from './configAssistant'
import { pages } from './pages'
import { initializeBrowserCache } from './browserCachePolicy'

const cache = new BrowserCache(false)
const initialCacheState = initializeBrowserCache(cache)

export const store = createStore({
  modules: {
    global: global(initialCacheState.global, cache),
    models: models(),
    agents: agents(initialCacheState.agents, cache),
    embeddings: embeddings(),
    prompts: prompts(),
    mcp: mcp(),
    providers: providers(),
    account: account(),
    workflows: workflows(),
    factories: factories(),
    scheduledRuns: scheduledRuns(),
    voices: voices(),
    admin: admin(),
    subscription: subscription(),
    pricing: pricing(),
    videoProcessing: videoProcessing(),
    configAssistant: configAssistant(),
    pages: pages()
  }
})

// export default createStore({
//   state: {},
//   getters: {},
//   mutations: {},
//   actions: {}
// })
